// 2、检测 JSAPI 是否就绪
const whenAPIReady = () => {
  return new Promise((resolve, reject) => {
    if (window.__SystemInfo__) {
      resolve()
      return
    }

    window.addEventListener('UBRReady', function () {
      resolve()
    })
  })
}
const versionUpdate = () => {
  UBRMBJSBridge.invoke('versionUpdate',{ }, (res) => {
  console.log('versionUpdate')
    if (res.status !== 'success') {
      console.log(res.errMsg)
    } 
  })
}
const exit = () => {
    UBRMBJSBridge.invoke('exit', { }, (res) => {
      console.log(res)
    })
}
export {
  whenAPIReady,
  versionUpdate,
  exit
}
